/**
 * Validation-error wiring shared by every widget: the input is marked invalid
 * and described by the message, which renders under the field.
 */

export function errorId(id: string): string {
  return `${id}-error`;
}

/** ARIA attributes for an input that may carry a validation error. */
export function fieldAria(id: string, error: string | null | undefined) {
  return error
    ? { "aria-invalid": true as const, "aria-describedby": errorId(id) }
    : { "aria-invalid": false as const };
}

export function FieldError({ id, error }: { id: string; error: string | null | undefined }) {
  if (!error) return null;
  return (
    <span id={errorId(id)} className="kn-field__error" role="alert">
      {error}
    </span>
  );
}
